import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/ga4/landing-page-layout"
import LandingPageSEO from "../components/ga4/landing-page-seo"
import LandingPageBuilder from "../components/landing-page-builder"
import Footer from "../components/footer"

const LandingPage = ({ data: { page } }) => {
  const layouts = page.landingPageGa4.landingPageBuilder

  return (
    <Layout>
      <LandingPageSEO />
      <div>
        {layouts.map((layout, index) => {
          return <LandingPageBuilder key={index} layoutData={layout} />
        })}
      </div>
      <Footer />
    </Layout>
  )
}

export default LandingPage

export const pageQuery = graphql`
  query {
    page: wpCustomPage(databaseId: { eq: 2949 }) {
      title
      landingPageGa4 {
        landingPageBuilder {
          ... on WpCustomPage_Landingpagega4_LandingPageBuilder_LandingPageContentBlock {
            fieldGroupName
            landingPageContent
            landingPageContentWidth
            addCalendlyLink
            bottomBorder
            centerLink
          }
          ... on WpCustomPage_Landingpagega4_LandingPageBuilder_ContentBlockWithImage {
            fieldGroupName
            landingPageImageContent
            contentWithImage {
              title
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            contentWithImageWidth
            imageAddCalendlyLink
          }
          ... on WpCustomPage_Landingpagega4_LandingPageBuilder_CountdownSection {
            fieldGroupName
            countdownTopContent
            countdownDate
            countdownLabel
            countdownBottomContent
            countdownButtonText
          }
          ... on WpCustomPage_Landingpagega4_LandingPageBuilder_ExpertSection {
            fieldGroupName
            expertSectionTopContent
            expertTeamMembers {
              ... on WpWLTeamMember {
                featuredImage {
                  node {
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                    }
                  }
                }
                title
                TeamMemberJobTitle {
                  tmJobTitle
                }
              }
            }
          }
          ... on WpCustomPage_Landingpagega4_LandingPageBuilder_ServiceCtas {
            fieldGroupName
            serviceCtasTitle
            optionOne {
              optionOneTitle
              optionOneDescription
              optionOneCost
            }
            optionTwo {
              optionTwoTitle
              optionTwoCost
            }
            optionThree {
              optionThreeTitle
              optionThreeCost
            }
          }
          ... on WpCustomPage_Landingpagega4_LandingPageBuilder_ServiceList {
            fieldGroupName
            serviceListTitle
            taskList {
              task
            }
          }
          ... on WpCustomPage_Landingpagega4_LandingPageBuilder_LandingPageLinks {
            fieldGroupName
            linksTopContent
            firstLink {
              firstLinkImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
              firstLinkTitle
              firstLinkDescription
              firstLinkLink
              firstLinkNewTab
            }
            secondLink {
              secondLinkImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
              secondLinkTitle
              secondLinkDescription
              secondLinkLink
              secondLinkNewTab
            }
          }
          ... on WpCustomPage_Landingpagega4_LandingPageBuilder_CalendlyEmbed {
            fieldGroupName
            calendlySectionId
            calendlyTopContent
            calendlyEmbedUrl
            calendlyCtaTitle
            calendlyCtaLink
            calendlyCtaLinkText
          }
        }
      }
    }
  }
`
